import { serverTrackAndIdentify } from 'utils/segment';

export const trackAmountCalculatorData = (type, data) => {
  const userProperties =
    type === 'submit home value'
      ? { amount_calculator_home_value: data.calculatorHomeValue }
      : { amount_calculator_investment_size: data.calculatorInvestmentSize };

  return serverTrackAndIdentify({
    event: 'Calculator Interaction Occurred',
    eventProperties: {
      calculator_name: 'up to amount',
      interaction_type: type,
      home_value: data.homeValue,
      investment_amount: data.investmentAmount,
      investment_amount_range_low: data.minMax?.min,
      investment_amount_range_high: data.minMax?.max,
      success: data.success,
      status_code: data.status_code,
    },
    userProperties: userProperties,
  });
};
